import React from "react";
import { Chip, Stack, Typography } from "@mui/material";

interface ChipSelectorProps {
  title: string;
  data: any[];
  labelKey: string;
  selected: string[];
  setSelected: (val: string[]) => void;
}

const ChipSelector: React.FC<ChipSelectorProps> = ({
  title,
  data,
  labelKey,
  selected = [],
  setSelected,
}) => {
  const handleToggle = (id: string) => {
    if (selected.includes(id)) {
      setSelected(selected.filter((s) => s !== id));
    } else {
      setSelected([...selected, id]);
    }
  };

  return (
    <Stack spacing={1} mb={2}>
      <Typography variant="subtitle1">{title}</Typography>
      <Stack direction="row" flexWrap="wrap" gap={1}>
        {data.map((item) => (
          <Chip
            key={item._id}
            label={item[labelKey]}
            clickable
            // color={selected.includes(item._id) ? "error.main" : "default"}
            onClick={() => handleToggle(item._id)}
            // sx={{
            //   color: selected.includes(item._id) ? "white" : "",
            //   background: selected.includes(item._id) ? "black" : "",
            //   "&:hover": {
            //     color: "white",
            //     backgroundColor: "black",
            //   },

            // }}
            sx={{
              color: selected.includes(item._id) ? "white" : "black",
              backgroundColor: selected.includes(item._id)
                ? "black"
                : "#E5E5E5",

              "&:hover": {
                backgroundColor: selected.includes(item._id)
                  ? "#333333"
                  : "#CFCFCF",
              },
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export default ChipSelector;
